import {Modal} from "../Modal";
import {Balance} from "./Balance";

require('../../../sass/components/CustomerBox/_balanceModal.scss');


export const BalanceModal = {
    name: 'BalanceModal',
    components: {
        Modal,
        Balance
    },
    props: {
        url: {
            type: String,
            default: '/'
        },
        balance: {
            type: Number,
            default: 0.00
        },
        balance_free_tax: {
            type: Number,
            default: 0.00
        },
        only_free_tax: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            free_tax: false
        }
    },
    mounted() {

    },
    methods: {
        open() {
            this.$modal.show('balance-modal');
        },
        close() {
            this.$modal.hide('balance-modal');
        }
    },
    template: `
        <Modal 
                name="balance-modal"
                class="balance-modal modal2--full-on-mobile"
                width="70%"
                height="90%"
                :scrollable="true"
                :withCloseButton="true"
                :clickToClose="false"
                >        
        <Balance :free_tax="free_tax" 
                 :url="url"
                 :balance="balance"
                 :balance_free_tax="balance_free_tax"
                 :only_free_tax="only_free_tax"
                 class="balance typography"></Balance>
        </Modal>
    `
}
